import { useState, useEffect } from 'react'
import LoadingSpinner from './LoadingSpinner'

interface SmoothLoadingSpinnerProps {
  isLoading: boolean
  delay?: number
  size?: 'sm' | 'md' | 'lg'
  message?: string
  className?: string
}

const SmoothLoadingSpinner = ({ 
  isLoading, 
  delay = 150, 
  size = 'md', 
  message = 'Loading...',
  className = ''
}: SmoothLoadingSpinnerProps) => {
  const [showSpinner, setShowSpinner] = useState(false)

  useEffect(() => {
    let timeoutId: NodeJS.Timeout

    if (isLoading) {
      // Add a small delay before showing the spinner to prevent flickering
      timeoutId = setTimeout(() => {
        setShowSpinner(true)
      }, delay)
    } else {
      // Hide immediately when loading is done
      setShowSpinner(false)
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [isLoading, delay])

  if (!showSpinner) {
    return null
  }

  return (
    <LoadingSpinner 
      size={size} 
      message={message} 
      className={className}
    />
  )
}

export default SmoothLoadingSpinner 